import { Dialogs } from '@leverege/ui-elements';
import I18N from '@leverege/i18n';
import CreateTemporaryUserDialog from "../components/CreateTemporaryUserDialog.js";
const {
  t,
  tf,
  tIcon
} = I18N.ns('temporaryUserManagement.action.Create');
export default {
  id: 'temporaryUserManagement.action.Create',
  type: 'ResourceTemporaryUsers.create',
  name: tf('name'),
  matches: {
    client: 'ResourceTemporaryUsers',
    use: 'actionBar'
  },
  prepare: async context => {
    const {
      clientProps: {
        allowed,
        actions,
        dispatch
      }
    } = context;
    if (typeof allowed.createTemporaryUser !== 'boolean') {
      return dispatch(actions.temporaryUsers().canCreate());
    }
    return null;
  },
  isPrepared: context => {
    const {
      clientProps: {
        allowed
      }
    } = context;
    return typeof allowed.createTemporaryUser === 'boolean';
  },
  handles: context => {
    const {
      clientProps: {
        allowed
      }
    } = context;
    return allowed.createTemporaryUser;
  },
  appearance: ({
    cxt
  }) => {
    return {
      name: t('appearanceName'),
      icon: tIcon('icon', 'fa fa-plus')
    };
  },
  perform: ({
    context,
    action
  }) => {
    const {
      clientProps: {
        resourceId,
        projectId,
        selectorProps,
        actions,
        Selector,
        allowed,
        systemId,
        getResourceName
      },
      emailOptions,
      smsOptions,
      uiName,
      uiUrl
    } = context;
    Dialogs.show({
      id: 'temporaryUserManagement.action.Create',
      component: CreateTemporaryUserDialog,
      props: {
        resourceId,
        projectId,
        selectorProps,
        actions,
        Selector,
        allowed,
        emailOptions,
        smsOptions,
        uiName,
        uiUrl,
        systemId,
        getResourceName
      }
    });
  }
};